import { useState } from "react";
import { api, formatApiErrorDetail } from "../lib/api";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "./ui/dialog";

export default function CreateAccountDialog({ open, onClose, onSaved }) {
  const [name, setName] = useState("");
  const [opening, setOpening] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await api.post("/accounts", {
        name: name.trim(),
        opening_balance: opening === "" ? 0 : parseFloat(opening),
      });
      setName("");
      setOpening("");
      onSaved?.();
      onClose();
    } catch (e) {
      setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="glass-strong rounded-3xl border-white/80 max-w-md">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl">New account</DialogTitle>
          <DialogDescription>
            Add someone to your ledger. Opening balance is optional.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={save} className="space-y-4">
          <div>
            <label className="label-tiny">Name</label>
            <input
              autoFocus
              type="text"
              required
              data-testid="account-name-input"
              className="w-full mt-1 px-4 py-3 rounded-2xl bg-white/70 border border-white/80 focus:bg-white outline-none focus:ring-2 focus:ring-[color:var(--gold)]/40"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div>
            <label className="label-tiny">Opening balance (optional)</label>
            <input
              type="number"
              step="any"
              data-testid="account-opening-input"
              className="w-full mt-1 px-4 py-3 rounded-2xl bg-white/70 border border-white/80 focus:bg-white outline-none focus:ring-2 focus:ring-[color:var(--gold)]/40 font-serif text-lg"
              value={opening}
              onChange={(e) => setOpening(e.target.value)}
              placeholder="0"
            />
          </div>
          {err && (
            <div className="text-sm text-red-600 bg-red-50/70 border border-red-100 rounded-xl px-3 py-2">
              {err}
            </div>
          )}
          <div className="flex gap-3 pt-2">
            <button type="button" onClick={onClose} className="btn-ghost flex-1">
              Cancel
            </button>
            <button
              type="submit"
              disabled={busy || !name.trim()}
              className="btn-gold flex-1"
              data-testid="account-save-btn"
            >
              {busy ? "Saving…" : "Create"}
            </button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
